import { organisasjonsformer } from "./organisasjonsformer"
import { mvaRegistrert } from "./mvaRegistrert"
import { isKontonummer } from "./isKontonummer"
import { getParams, UrlParams } from "./paramsStorage"

const initialParams = Object.freeze<UrlParams>({
  orgForm: "enk",
  medMva: "medMva",
})

export const defaultParams: UrlParams = (getParams() as UrlParams) ?? initialParams

const gyldigeOrgFormer: string[] = Object.values(organisasjonsformer).map((value) => value.id)
const gyldigeMvaValg: string[] = Object.values(mvaRegistrert)

type PathBuilderReturnType = {
  refresh: boolean
  path: string
}

export function pathBuilder(
  { orgForm, medMva }: UrlParams,
  kontonummer: string | undefined = undefined,
): PathBuilderReturnType {
  const hasOrg = gyldigeOrgFormer.includes(orgForm)
  const hasMva = gyldigeMvaValg.includes(medMva)
  const isKonto = isKontonummer(kontonummer)

  const orgParam = `/${hasOrg ? orgForm : defaultParams.orgForm}`
  const mvaParam = `/${hasMva ? medMva : (defaultParams.medMva ?? initialParams.medMva)}`
  const kontoParam = isKonto && kontonummer !== undefined ? `/${kontonummer}` : ""

  const path = `${orgParam}${mvaParam}${kontoParam}`
  const refresh = !(hasMva && hasOrg) || (kontonummer !== undefined && !isKontonummer(kontonummer))

  return { refresh, path }
}
